module.exports = __webpack_public_path__ + "242dbae4a75899b69a1427cddcef7402.MP3";